import React from "react";
import styled from "styled-components/native";

// Simple image component that pulls the image from the theme
const Logo = styled.Image`
  ${props => props.theme.logoStyle}
`;

export default Logo;
